module.exports = __webpack_public_path__ + "./fonts/Hero-New-Bold.otf";